// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const mapViewActions = {
  GET_CN_DATA: 'GET_CN_DATA',
  UPDATE_FILTER: 'UPDATE_FILTER',
  SET_MAP_OBJECT: 'SET_MAP_OBJECT'
};

export const doAction = (type, payload) => ({
  type,
  payload
});

export const updateFilter = (key, payload) => ({
  type: mapViewActions.UPDATE_FILTER,
  key,
  payload
});

export const setMapObj = payload =>
  doAction(mapViewActions.SET_MAP_OBJECT, payload);

const failureCb = (res, dispatch) => {
  // eslint-disable-next-line
  console.log('Failure to get data ', res);
  dispatch(
    doAction(mapViewActions.GET_CN_DATA, {
      isLoading: false,
      isLoaded: true,
      cnData: []
    })
  );
  toastr.error(
    'Something went wrong!',
    res.errorMessage || 'Could not get cn data'
  );
};

export const getCnData = () => dispatch => {
  dispatch(
    doAction(mapViewActions.GET_CN_DATA, {
      isLoading: true,
      isLoaded: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'cnMapViewData',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          doAction(mapViewActions.GET_CN_DATA, {
            isLoading: false,
            isLoaded: true,
            cnData: res.payload,
            cnDataFetchTime: Date.now()
          })
        );
      } else {
        failureCb(res, dispatch);
      }
    },
    failureCb: res => failureCb(res, dispatch),
    catchCb: res => failureCb(res, dispatch)
  };

  return makeApiCall(requestObj);
};
